export default [
  {
    t: 'JS 2015', p: '4', checked: false, h: 'https://babeljs.io/docs/learn-es2015/'
  },
  {
    t: '自訂Vue部件混入子(Mixins)', p: '4', checked: false, h: 'https://vuejs.org/guide/mixins.html'
  },
  {
    t: '自訂Vue指示物', p: '4', checked: false
  },
  {
    t: 'Webpack', p: '4', checked: false, h: 'http://webpack.github.io/docs/', note: 'v1.x和v2.x的語法有不同'
  },
  {
    t: '程式啟動路由', p: '4', checked: false, h: 'http://router.vuejs.org/en/essentials/navigation.html', note: '.vue部件時要以this.$router來抓到router'
  },
  {
    t: '部件包裝器', p: '4', checked: false, h: 'http://012.vuejs.org/guide/components.html#Single_Insertion_Point'
  },
  {
    t: '部件插入包裝', p: '4', checked: false, h: 'https://vuejs.org/v2/guide/components.html#Content-Distribution-with-Slots'
  },
  {
    t: '串列漸變', p: '5', checked: false, h: 'https://vuejs.org/guide/transitions.html#List-Transitions'
  },
  {
    t: 'Webpack使用方式', p: '6', checked: false, h: 'http://webpack.github.io/docs/usage.html'
  },
  {
    t: 'Webpack載入子', p: '6', checked: false, h: 'http://webpack.github.io/docs/using-loaders.html'
  },
  {
    t: 'Vue-Firebase', p: '6', checked: false, h: 'https://github.com/vuejs/vuefire'
  },
  {
    t: '自訂Vue模組(Modules)', p: '6', checked: false, h: 'https://vuejs.org/guide/plugins.html'
  },
  {
    t: '自訂Vue的模版(Boilerplates)', p: '6', checked: false
  }
]
